import styles from "./PromotionTab.module.css";
import {PromotionTabType} from "../../interfaces/promotionTab/PromotionTab.type";
import PromotionTab from "./PromotionTab";
import {styleHelper} from "../../helpers/commonFunctions";
import {ComboPackageType} from "../../interfaces/comboPackage/ComboPackage.type";
import ComboPackageGroup from "../comboPackageGroup/ComboPackageGroup";

export default function PromotionTabContainer({
    items,
    scroll
}: {
    items: PromotionTabType[];
    scroll?: Boolean
}) {
    return (
        <div className={`vas-w-100`}>
            <div className={`vas-py-2`}>
                {scroll ? (
                    <div
                        className={`${styles.tab_border} vas-d-flex vas-gap-3`}
                        style={styleHelper({overflowX: "auto"})}
                    >
                        {items?.map((item: PromotionTabType, idx: number) => {
                            return <PromotionTab item={item} key={idx}/>;
                        })}
                    </div>
                ) : (
                    <div
                        className={`${styles.tab_border} vas-d-flex vas-gap-3`}
                    >
                        {items?.map((item: PromotionTabType, idx: number) => {
                            return <PromotionTab item={item} key={idx}/>;
                        })}
                    </div>
                )}
            </div>
        </div>

    );
}
